import React, { useEffect } from "react";
import { useAuth } from "../../contexts/auth";
import { useNavigate } from "react-router-dom";
import { PartnerPatientAddForm } from "../../components";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";

export default function PartnerAddPatientPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user.usertype === "CP" || user.usertype === "DIST") {
    } else {
      navigate("/");
    }
  });

  const breadcrumbItems = [
    { label: "Home", path: "/", active: false },
    {
      label: "Patient List",
      // path: "/partner-patient-info",
      path: "/partner-patient",
      active: false,
    },
    { label: "Create New Patient", path: "#", active: true },
  ];

  return (
    <React.Fragment>
      <Breadcrumb title="Create New Patient" items={breadcrumbItems} />
      <div className={"content-block dx-card responsive-paddings"}>
        <PartnerPatientAddForm />
      </div>
    </React.Fragment>
  );
}
